import { render, staticRenderFns } from "./ForumSearch.vue?vue&type=template&id=c723513a&"
import script from "./ForumSearch.vue?vue&type=script&lang=js&"
export * from "./ForumSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports